import Button3d from './Button3d'

export default Button3d
